export default {
    bindings: {
        'eventType': '=',
        'filter': '<',
        'displaySpaDays': '<'
    },
    controller: 'selectTypeController',
    template: require('../views/selectType.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/page/components/selectType.component.js